import React, { Component } from 'react';
import {Row,Col,Form} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'

import { MSG_REQUIRED } from '../../../configs/msgConfigs';
import { LBL_MUTE_EMAILS,LBL_MUTE_NOTICATIONS,LBL_PRIMARY_CONTACT, LBL_SELECT_CONTACT, LBL_FIRST_NAME, LBL_LAST_NAME, LBL_CONTACT_NUMBER, LBL_EMAIL_ADDRESS, LBL_POSITION, LBL_SAVE, LBL_NOT_VERIFIED, LBL_RESEND_VERIFI_EMAIL } from '../../../configs/labelConfigs';
import {PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../../configs/staticConfigs'; 

class PrimaryContact extends Component {

    render(){
        const { affiliateData, isPrmCnctList, formErrors,users, /*isPrimaryContactSuccess*/ } = this.props; 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;
        return(
            <Form onSubmit={e => this.props.updateFormData(e)}>
                <Form.Group>
                    <div className="box">
                        <div className="tab-head">
                            <h6>{LBL_PRIMARY_CONTACT} {(companyName) && <span>{' - '+companyName}</span>} </h6>
                        </div>
                        <div className="box-content">
                            {isPrmCnctList ? (
                                    <Row>
                                        <Col md={6}>
                                                                                                                                                                  <label>{LBL_SELECT_CONTACT}</label>
                                            <div className="form-group select-input">
                                                <select name="prmyCnctAssUserId" value={affiliateData.primaryContact.prmyCnctAssUserId || ''} onChange={e => this.props.onSelectPrmyUser(e)}>
                                                    
                                                    {users.map((item) => <option key={item.associate_id} value={item.associate_id}>{item.first_name+' '+item.last_name}</option>)}  
                                                </select>
                                            </div>                                
                                        </Col>
                                    </Row>
                                ) : (
                                    <React.Fragment></React.Fragment>
                                )}                                               
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_FIRST_NAME}</label>
                                        <div className="text-input"><input disabled={isPrmCnctList} type="text" name="firstName" onChange={this.props.onHandleChange} className={formErrors.firstName.length >0 ? "input-error" : ''} value={affiliateData.primaryContact.firstName || '' } maxLength={25} /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_LAST_NAME}</label>
                                        <div className="text-input"><input disabled={isPrmCnctList} type="text" className={formErrors.lastName.length >0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="lastName" value={affiliateData.primaryContact.lastName || ''} maxLength={25} /></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_CONTACT_NUMBER}</label>
                                        <div className={formErrors.contactNumber.length >0 ? "input-error" : ''}>                                       
                                            <PhoneInput
                                              country={PHONE_ISD_CODE}
                                              inputProps={{
                                                name: 'contactNumber',
                                              }}
                                              value={affiliateData.primaryContact.contactNumber || PHONE_ISD_NUM}
                                              onChange={this.props.onContactInputChange} 
                                              disabled={isPrmCnctList}
                                            />
                                        </div>
                                    </div>
                                </Col> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_EMAIL_ADDRESS}</label>
                                        <div className="input email-input"><input disabled={isPrmCnctList} type="email" className={formErrors.emailAddress.length >0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="emailAddress" value={affiliateData.primaryContact.emailAddress || ''} maxLength={120}/></div>
                                        {formErrors.emailAddress.length >0 && formErrors.emailAddress!==MSG_REQUIRED && (
                                            <div className="text-red left-align text-12">{formErrors.emailAddress}</div>
                                        )}
                                        <small className="text-red">{affiliateData.primaryContact.emailVerify===false&&affiliateData.primaryContact.emailAddress?LBL_NOT_VERIFIED:''}</small>
                                        <Link className={affiliateData.primaryContact.emailVerify===false&&affiliateData.primaryContact.emailAddress?'resend-btn float-right':'hide'} to="#" onClick={e => this.props.resendEmail(affiliateData.primaryContact.prmyCnctUserId)}>{LBL_RESEND_VERIFI_EMAIL}</Link>
                                    </div>
                                </Col>
                            </Row>  
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_POSITION}</label>
                                        <div className="input-input"><input disabled={isPrmCnctList} type="text" onChange={this.props.onHandleChange} name="position" value={affiliateData.primaryContact.position || ''} maxLength={120}/></div>
                                    </div>
                                </Col>
                                <Col md={6} >
                                    <div className="checkbox-wrapper conct-detailss form-group">
                                        <p>  </p>
                                        <p>  </p>
                                        <div className="custom-checkbox i-margin-top">
                                            <input onChange={(e)=>this.props.onHandleChange(e,'tab3')} name="muteMails" 
                                            checked={affiliateData.primaryContact.muteMails} type="checkbox" id="muteMails" tabIndex="8" /><label className="checkbox" htmlFor="muteMails"  tabIndex="8"  ></label><label className="labeltext" htmlFor="muteMails">{LBL_MUTE_EMAILS}</label>
                                        </div>
                                     
                                        <div className="custom-checkbox i-margin-top">
                                            <input onChange={(e)=>this.props.onHandleChange(e,'tab3')} name="mutePushs" 
                                            checked={affiliateData.primaryContact.mutePushs} type="checkbox" id="mutePushs" tabIndex="8" /><label className="checkbox" htmlFor="mutePushs"  tabIndex="8"  ></label><label className="labeltext" htmlFor="mutePushs">{LBL_MUTE_NOTICATIONS}</label>
                                        </div>
                                    </div>
                                </Col>
                                
                            </Row>                           
                            <div className="clearfix">
                                {/* <button disabled={isPrimaryContactSuccess===true && isPrmCnctList===false} type="submit" className="btn btn-primary float-right">Save</button> */}
                                <button type="submit" className="btn btn-primary float-right">{LBL_SAVE}</button>
                            </div>
                        </div>
                    </div>
                </Form.Group>
            </Form>
        )
    }

}
export default PrimaryContact;